import { GIT_INTEGRATION_BASE_PATH } from '../consts';
import { getServerUrl } from '../utils';

export const GIT_INTEGRATION_GITLAB_BASE_URL = new URL(
  `${getServerUrl()}${GIT_INTEGRATION_BASE_PATH}/gitlab`,
).toString();
